import { BrandliveEvent, PageModule, PageModuleType, SessionTypesEnum } from "../../../../../../../types/working-model";
import ModalComponent from "../../../../../../general-ui/modal/modal";
import SelectModuleLayout from "./select-module-layout";
import './edit-module-layout-modal.scss';
// import TabHeader from "../../../../../../general-ui/tab-header/tab-header";
import { useEffect, useMemo, useState } from "react";
import { AllLayoutTypes } from "../../../../../../../types/template-layouts";
import AdvancedLayoutSettings from './advanced-settings';
import { useDispatch, useSelector } from "react-redux";
import { EventsState } from "../../../../../../../store/types";
import { updateWorkingEvent } from "../../../../../../../store/actions/admin/create-event";
import { IEditableContent } from "../../../../session/editor/moduleControls/controls";

interface Props {
	open: boolean;
	pageModuleType?: PageModuleType | null;
	setOpenLayoutModal: React.Dispatch<React.SetStateAction<PageModuleType | null>>;
	selectedModule: PageModule["id"] | null;
	title: string;
	editModule?: IEditableContent;
}

enum ETabOptions {
	layout = 'Layout',
	content = 'Content',
	animation = 'Animation',
	link = 'Link'
}

const EditLayoutModal: React.FC<Props> = ({
	open,
	setOpenLayoutModal,
	selectedModule,
	title: sectionName,
	pageModuleType,
	editModule,
}) => {

	const {
		CreateEventReducer: {
			workingEvent
		},
		AuthReducer: {
			token,
		}
	} = useSelector((event: EventsState) => event);

	const dispatch = useDispatch();

	const [selectedLayout, setSelectedLayout] = useState<AllLayoutTypes | null>(null);
	const [activeTab, setActiveTab] = useState(ETabOptions.layout);
	const [hasAdvancedSettings, setHasAdvancedSettings] = useState(false);

	const handleClose = () => {
		setOpenLayoutModal(null);
		setActiveTab(ETabOptions.layout);
	};

	const moduleEdits = useMemo(() => {
		switch (activeTab) {
			case ETabOptions.layout: {
				const module = workingEvent?.homepage?.modules?.find((module: PageModule) => (module.id === selectedModule));
				if (pageModuleType === PageModuleType.main_event_banner) {
					const isBroadcastEvent = workingEvent?.sessions.some(session => session.session_type === SessionTypesEnum.broadcast);
					// if this event has no broadcast times dont show the advanced settings for main event banner as they only toggle the countdown on/off
					if (!isBroadcastEvent) setHasAdvancedSettings(false);
				}
				return (
					<>
						<SelectModuleLayout
							selectedModule={selectedModule}
							selectedLayout={selectedLayout}
							setSelectedLayout={setSelectedLayout}
						/>
						{
							hasAdvancedSettings &&
							<AdvancedLayoutSettings
								selectedModule={pageModuleType!}
								module={module}
							/>
						}
					</>
				);
			}
			// case ETabOptions.content: {
			// 	return editModule?.jsx;
			// }
			case ETabOptions.link: {
				return editModule?.jsx;
			}
		}
	}, [
		activeTab,
		selectedModule,
		selectedLayout,
		hasAdvancedSettings,
		pageModuleType,
		editModule,
		workingEvent?.homepage?.modules,
		workingEvent?.sessions
	]);

	// FUTURE DEV: add back in when implementing animations
	// each module can have different editable content from here
	// const moduleEditTabs = useMemo(() => {
	// 	switch (pageModuleType) {
	// 		case PageModuleType.products:
	// 			setHasAdvancedSettings(true);
	// 			return [ETabOptions.layout];
	// 		case PageModuleType.main_event_banner:
	// 			setHasAdvancedSettings(true);
	// 			return [ETabOptions.layout];
	// 		case PageModuleType.callout:
	// 			return [ETabOptions.layout, ETabOptions.link];
	// 		case PageModuleType.agenda:
	// 			setHasAdvancedSettings(false);
	// 			return [ETabOptions.layout];
	// 		default:
	// 			return [ETabOptions.layout];
	// 	}
	// }, [pageModuleType]);

	// FUTURE DEV: wont need this block when uncommenting out the above switch statement
	useEffect(() => {
		switch (pageModuleType) {
			case PageModuleType.main_event_banner:
				setHasAdvancedSettings(true);
				break;
			case PageModuleType.callout:
			case PageModuleType.agenda:
				setHasAdvancedSettings(false);
		}
	}, [pageModuleType]);

	function handleDone() {
		if (!workingEvent || !workingEvent?.homepage) { return; }
		const updatedWorkingEvent: BrandliveEvent = {
			...workingEvent,
			homepage: {
				...workingEvent.homepage,
				modules: workingEvent?.homepage?.modules?.map((module: PageModule) => {
					if (module.id === selectedModule) {
						return {
							...module,
							content: {
								...module.content,
								layout_type: selectedLayout,
							},
						};
					}
					return module;
				}),
			},
		};
		dispatch(updateWorkingEvent(updatedWorkingEvent, token!));
		setOpenLayoutModal(null);
		setActiveTab(ETabOptions.layout);
	}

	function handleDoneEditModule() {
		if (editModule?.onDone) {
			editModule.onDone();
			setOpenLayoutModal(null);
		}
	}


	return (
		<div className="edit-layout-modal-container">
			<ModalComponent
				cancellable={true}
				closeable={false}
				open={open}
				onRequestClose={handleClose}
				title={`Change ${sectionName} layout`}
				size="large"
				footer={(
					<>
						<button
							style={{ marginRight: 16 }}
							onClick={handleClose}
						>
							Cancel
						</button>
						<button
							className="primary"
							onClick={activeTab === ETabOptions.layout ? handleDone : handleDoneEditModule}
						>
							Done
						</button>
					</>
				)}
			>
				{/* 
					FUTURE DEV: add back in when implementing animations
					<TabHeader
						tabs={moduleEditTabs}
						onClick={setActiveTab}
						currentTab={activeTab}
					/> 
				*/}
				<div className="edit-layout-modal-content">
					{moduleEdits}
				</div>
			</ModalComponent>
		</div>
	);
};

export default EditLayoutModal;
